import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './Containers/Login/Login';
import SelectFolder from './Containers/SelectFolder/SelectFolder';
import UploadDetails from './Containers/UploadDetails/UploadDetails';
import UploadDetailsType from './Containers/UploadDetails/Upload/Upload';
import UploadData from './Containers/UploadData/UploadData';
import UploadDataType from './Containers/UploadData/Upload/Upload';
import GetData from './Containers/GetData/GetData';
import Get from './Containers/GetData/Get/Get';
import Manage from './Containers/UserManager/Manage';
// import Home from './Containers/Home/Home';
import './App.scss';
import Weather from './Containers/Pages/Weather';
import Synoptic from './Containers/Pages/Synoptic';
import Hydrometric from './Containers/Pages/Hydrometric';
import Lake from './Containers/Pages/Lake';
import Watershed from './Containers/Pages/Watershed';
import Aquifer from './Containers/Pages/Aquifer';
// import Sidebar from './Components/Sidebar/Sidebar';

const App = () => {
  const userIsAuthorized = useSelector((state) => state.auth.IsAuthorized);

  if (!userIsAuthorized) {
    return (
      <Switch>
        <Route path='/login' exact component={Login} />
        <Redirect to='/login' />
      </Switch>
    );
  } else {
    // const sidebars = [
    //   { title: 'عضویت کاربر', url: '/UserManager' },
    //   { title: 'دریاچه', url: '/Lake' },
    //   { title: 'ایستگاه هیدرومتریک', url: '/Hydrometric' },
    //   { title: 'ایستگاه سینوپتیک', url: '/Synoptic' },
    //   { title: 'سد', url: '/Dam' },
    //   { title: 'آبخوان', url: '/Aquifer' },
    //   { title: 'ایستگاه هواشناسی', url: '/WeatherStation' },
    //   { title: 'حوضه آبریز', url: '/Watershed' },
    // ];

    return (
      <Switch>
        <Route path='/AddInvidualData' exact component={UploadDetails} />
        <Route path='/AddInvidualData/:type' exact component={UploadDetailsType} />

        <Route path='/UploadData' exact component={UploadData} />
        <Route path='/UploadData/:type' exact component={UploadDataType} />

        <Route path='/GetData' exact component={GetData} />
        <Route path='/GetData/:type' exact component={Get} />

        <Route path='/UserManager' exact component={null} />
        <Route path='/UserManager/:type' exact component={Manage} />

        <Route path='/Lake' exact component={null} />
        <Route path='/Lake/:type' exact component={Lake} />

        <Route path='/Hydrometric' exact component={null} />
        <Route path='/Hydrometric/:type' exact component={Hydrometric} />

        <Route path='/Synoptic' exact component={null} />
        <Route path='/Synoptic/:type' exact component={Synoptic} />

        {/* <Route path='/Dam' exact component={null} />
        <Route path='/Dam/:type' exact component={Manage} /> */}

        <Route path='/Aquifer' exact component={null} />
        <Route path='/Aquifer/:type' exact component={Aquifer} />

        <Route path='/WeatherStation' exact component={null} />
        <Route path='/WeatherStation/:type' exact component={Weather} />

        <Route path='/Watershed' exact component={null} />
        <Route path='/Watershed/:type' exact component={Watershed} />

        <Route path='/SelectFolder' exact component={SelectFolder} />

        {/* <Route path='/' exact component={Home} /> */}
        <Route path='/' exact component={null} />
        <Redirect to='/' />
      </Switch>
    );
  }
};

export default App;
